export enum IProcessStatus {
	loading = 'loading',
	validating = 'validating',
	statusChecking = 'status checking',
	created = 'created',
	saved = 'saved',
	sent = 'sent',
	done = 'done',
	failed = 'failed',
}
